import { render, staticRenderFns } from "./BoothControlPanel.vue?vue&type=template&id=59304480"
import script from "./BoothControlPanel.vue?vue&type=script&lang=ts"
export * from "./BoothControlPanel.vue?vue&type=script&lang=ts"
import style0 from "./BoothControlPanel.vue?vue&type=style&index=0&id=59304480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports